import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVT = "carspa:availability";

let cache = null;

export const refreshAvailability = async () => {
  const { data } = await axios.get(`${API}/availability`);
  cache = data;
  window.dispatchEvent(new CustomEvent(EVT, { detail: data }));
  return data;
};

/** Live weekly capacity: {capacity, booked, remaining} — shared across sections. */
export function useAvailability() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    const fn = (e) => setData(e.detail);
    window.addEventListener(EVT, fn);
    if (!cache) refreshAvailability().catch(() => {});
    return () => window.removeEventListener(EVT, fn);
  }, []);
  return data;
}

/** Copy helpers so every section says the same thing. */
export const urgencyBadge = (a) => {
  if (!a) return "Volná místa tento týden — termíny rychle mizí";
  if (a.remaining <= 0) return "Tento týden plno — rezervujte na příští týden";
  if (a.remaining <= 3) return `Poslední ${a.remaining} ${a.remaining === 1 ? "místo" : "místa"} tento týden!`;
  return `Volná místa tento týden: ${a.remaining} z ${a.capacity} — termíny rychle mizí`;
};

export const urgencyShort = (a) => {
  if (!a) return "Volná místa tento týden rychle mizí";
  if (a.remaining <= 0) return "Tento týden plno — příští týden ještě volno";
  return `Zbývá ${a.remaining} ${a.remaining === 1 ? "místo" : a.remaining < 5 ? "místa" : "míst"} tento týden`;
};
